import React, { useContext } from "react";
import { Link } from "react-router-dom";
import "pure-react-carousel/dist/react-carousel.es.css";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";

const CategoryCarousel = () => {
  const { categories } = useContext(StoreContext);

  return (
    <div className="categoryBrowserHolder">
      <div className="categoryBrowserHolder__content">
        {categories.loaded ? (
          <div>
            <h3>Browse products by category</h3>
            <div className="categoryBrowser">
              {categories.tree.map(cat => (
                <div className="singleCategoryBrowserItem" key={cat.id}>
                  <Link to={cat.path}>
                    <img id={cat.id} src={cat.darkIcon} alt={cat.text} />
                    <h4>{cat.text}</h4>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default CategoryCarousel;
